import styled from 'styled-components';

import { WITH_ID_SUFFIX } from 'components/insights/constants';
import Export from 'components/insights/layout/details/Export';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import useWebsocketExport from 'hooks/useWebsocketExport';
import { createAnalyticsExport } from 'services/api/insights/analytics';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
  analyticsFilters: Record<string, unknown> | null;
};

export default function InsightsApiExport({
  disabled = false,
  filename,
  show = true,
  params,
  analyticsFilters,
}: Props) {
  const { initiateExport, exporting } = useWebsocketExport(createAnalyticsExport);

  const handleClick = () => {
    if (!analyticsFilters) return;
    initiateExport({
      params: {
        ...params,
        dimensions: params.dimensions?.map((d) => (typeof d === 'string' ? d.replace(WITH_ID_SUFFIX, '') : d)),
        filename,
      },
      filters: analyticsFilters,
    });
  };

  return (
    <StyledExport disabled={disabled || !analyticsFilters} show={show} loading={exporting} onClick={handleClick} />
  );
}

const StyledExport = styled(Export)`
  margin-left: auto;
`;
